import { createFileRoute } from "@tanstack/react-router";
import React, { useEffect } from "react";

export const Route = createFileRoute(
  "/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm/html"
)({
  component: RouteComponent,
});

function RouteComponent() {
  useEffect(() => {
    // Redirect to the static file in public/
    window.location.replace(
      "/zalo_verifierEDxa6-_kSneGvkW7nl9SMZZYocJKb1i_D3Cm.html"
    );
  }, []);

  return <div style={{ padding: 16 }}>Đang chuyển hướng...</div>;
}

export default RouteComponent;
